import { getCorrectDateFromISO } from '@/utils/dates/getCorrectDateFromISO';

export const formatDraftUpdatedAt = (value?: string | null): string | null => {
	if (!value) {
		return null;
	}

	return getCorrectDateFromISO(new Date(value), 'dd.MM.yyyy HH:mm');
};
